import React from 'react';
import styled from 'styled-components';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Input, Form, Button, Space } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';

const styleIcon = (icon: typeof MailOutlined) => styled(icon)`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.iconColor};
`;

const StyledMailOutlined = styleIcon(MailOutlined);
const StyledLockOutlined = styleIcon(LockOutlined);

const LoginInput = styled(Input)`
  height: 32px;
  border-radius: 6px;
  .ant-input {
    font-size: 15px;
    border: none;
  }
  .ant-input-prefix {
    padding-right: 4px !important;
  }
`;

const ForgotButton = styled(Button)`
  display: block !important;
  padding: 5px 16px !important;
  height: auto !important;
  font-size: 14px !important;
  color: ${(props) => props.theme.gray} !important;
`;

const LoginFormItem = styled(Form.Item)`
  margin-bottom: 16px !important;
  width: 100%;
`;

export type LoginFormValues = {
  email: string;
  password: string;
};

const LoginForm: React.FC<{ onLogin: (values: LoginFormValues) => void }> = ({
  onLogin,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm<LoginFormValues>();

  return (
    <Form
      form={form}
      onFinish={(values) => {
        onLogin({
          email: values.email.trim().toLowerCase(),
          password: values.password.trim(),
        });
      }}
      layout="vertical"
      css="width: 100%;"
    >
      <Space
        orientation="vertical"
        css="width: 100%; row-gap: 0px;"
        size="large"
      >
        <LoginFormItem
          name="email"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage:
                  'No email provided. Please enter your email address.',
              }),
            },
          ]}
        >
          <LoginInput
            size="medium"
            prefix={<StyledMailOutlined />}
            placeholder={intl.formatMessage({ defaultMessage: 'Email' })}
          />
        </LoginFormItem>
        <LoginFormItem
          name="password"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage:
                  'No password provided. Please enter your password.',
              }),
            },
          ]}
        >
          <LoginInput
            size="medium"
            type="password"
            prefix={<StyledLockOutlined />}
            placeholder={intl.formatMessage({ defaultMessage: 'Password' })}
          />
        </LoginFormItem>
      </Space>
      <LoginFormItem>
        <Button type="primary" htmlType="submit" block>
          <FormattedMessage defaultMessage="Login" />
        </Button>
      </LoginFormItem>

      <LoginFormItem css="text-align:center;">
        <ForgotButton type="link" href="/forgot-password">
          <FormattedMessage defaultMessage="Forgot your password?" />
        </ForgotButton>
      </LoginFormItem>
    </Form>
  );
};

export default LoginForm;
